/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Delete, EditNote, MenuBook } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Tooltip,
} from "@mui/material";
import { Box } from "@mui/system";
import {
  DataGrid,
  GridAlignment,
  GridColDef,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import AxiosInstance from "../../API/axios";
import { usePagePermissions } from "../../Components/PagePermission";
import Layout from "../../Components/Layout";
import AddItemButton from "../../Components/AddItemButton";
import theme from "../../theme";
type Props = {};

interface WrapTextCellProps {
  value: string; // Assuming Address_1 is of type string
}

interface Role {
  [key: string]: any; // Add index signature
  Id: number;
  Role_Name: string;
  Role_Description: string;
  Is_Active: number;
  Created_By: number;
  Created_Date: null | Date;
  Updated_By: null | number;
  Updated_Date: null | Date; // Assuming the date will be a string if not null
}

export default function RolesManage({}: Props) {
  const permissions = usePagePermissions(7);
  const navigate = useNavigate();
  const [rows, setRows] = useState<Role[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedRow, setSelectedRow] = useState<Role | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectedid, setSelectedId] = useState<number[]>([]);

  // Function to open the delete modal
  const openDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  // Function to close the delete modal
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const get_roles = async () => {
    try {
      const response = await AxiosInstance.get("/admin/roles/v1/get-all-roles");
      const data = response.data;
      console.log(data);
      return data;
    } catch (error) {
      console.log("Error retrieving roles:", error);
      return []; // Return an empty array in case of error
    }
  };

  const base64encode = (string: string | number) => {
    string = string.toString();
    return btoa(string);
  };

  const handleEditClick = (roleid: number) => {
    console.log("Edit clicked");
    navigate(`/roles/edit/${base64encode(roleid)}`);
  };

  const getRowId = (row: Role) => row.Id;

  // const formatDate = (dateString: string) => {
  //   const date = parseISO(dateString);
  //   return format(date, "M/dd/yyyy h:mm:ss a");
  // };

  const WrapTextCell: React.FC<WrapTextCellProps> = ({ value }) => {
    return <div style={{ whiteSpace: "pre-wrap" }}>{value}</div>;
  };

  //allow multiple row selections

  const deleteModalContent = () => (
    <Box className="flex flex-col items-center w-1/3 bg-white rounded-lg gap-y-4 h-2/5">
      <div className="flex flex-row items-center justify-center w-full bg-primary h-1/6">
        <h6 className="text-lg text-white">Confirm Delete</h6>
      </div>
      <p className="text-lg text-black">
        You are about to delete the following roles:
      </p>
      <List>
        {selectedid.map((id) => {
          const selectedRow = rows.find((row) => row.Id === id);
          return (
            <ListItem key={id}>
              <ListItemIcon>
                <Checkbox checked={true} />
              </ListItemIcon>
              <ListItemText primary={selectedRow?.Role_Name} />
            </ListItem>
          );
        })}
      </List>
      <div className="flex flex-row items-center justify-center gap-x-4">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            deleteRoles();
          }}
        >
          <span className="text-white">Confirm</span>
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={closeDeleteModal}
        >
          <span className="text-primary">Cancel</span>
        </Button>
      </div>
    </Box>
  );

  const deleteRoles = async () => {
    let deleteIds: number[] = [];
    //extract roleids from selectionModel
    selectedid.forEach((id) => {
      const selectedRow = rows.find((row) => row.Id === id);
      deleteIds.push(selectedRow?.Id as number);
    });
    console.log("delete", deleteIds);
    const data = {
      Roles_Id: deleteIds,
    };
    console.log(data);
    try {
      const res = await AxiosInstance.post(
        "/admin/roles/v1/delete-roles",
        data
      );
      if (res.status === 200) {
        setSelectedId([]);
        closeDeleteModal();
        // logEvent(7, 4, deleteIds[0].toString());
        toast.success("Roles deleted successfully");
        navigate("/roles/manage");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error deleting roles");
    }
  };

  //log out current selection

  const columns: GridColDef[] = [
    {
      field: "Sr. No.",
      headerName: "Id",
      cellClassName: "text-black",
      width: 70,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        // Find the index of the row in the rows array and add 1
        const rowIndex = rows.findIndex((row) => row.Id === params.row.Id) + 1;
        return <div>{rowIndex}</div>;
      },
      headerClassName:
        "bg-primary text-white font-bold flex flex-row items-center ",
    },
    {
      field: "Role_Name",
      headerName: "Role Name",
      cellClassName: "text-black",
      width: 300,
      headerAlign: "center",
      align: "center",
      headerClassName:
        "bg-primary text-white font-bold flex flex-row items-center ",
      renderCell: (params) => <WrapTextCell value={params.value} />,
    },
    // {
    //   field: "Id",
    //   headerName: "ID",
    // cellClassName: "text-black",
    //   width: 90,
    //   headerAlign: "center",
    //   align: "center",
    //   headerClassName:
    //     "bg-primary text-white font-bold flex flex-row items-center ",
    // },
    ...(permissions?.Update || permissions?.View || permissions?.Delete
      ? [
          {
            field: "Actions",
            headerName: "Actions",
            cellClassName: "text-black",
            headerAlign: "center" as GridAlignment, // Corrected type
            align: "center" as GridAlignment, // Corrected type
            headerClassName:
              "bg-primary text-white font-bold flex flex-row items-center",
            width: 150,
            renderCell: (params: GridRenderCellParams) => (
              <div className="flex flex-row gap-x-1">
                {permissions?.View ? (
                  <div className="flex items-center">
                    <div
                      className="px-1.5 py-0.5 rounded-md text-View cursor-pointer flex flex-row items-center justify-center"
                      onClick={() => {
                        handleViewClick(params.row.Id as number);
                        console.log("Role Id ", params.row.Id);
                      }}
                    >
                      <Tooltip title="View">
                        <MenuBook sx={{ fontSize: "20px" }} />
                      </Tooltip>
                    </div>
                  </div>
                ) : null}
                {permissions?.Update ? (
                  <div className="flex items-center ">
                    <div
                      className="px-1.5 py-0.5 rounded-md text-Edit cursor-pointer"
                      onClick={() => {
                        handleEditClick(params.row.Id as number);
                        console.log("Role Id ", params.row.Id);
                      }}
                    >
                      <Tooltip title="Edit Status">
                        <EditNote sx={{ fontSize: "20px" }} />
                      </Tooltip>
                    </div>
                  </div>
                ) : null}

                {permissions?.Delete ? ( // Conditional rendering based on isRenewal
                  <div className="flex items-center">
                    <div
                      className="px-1.5 py-0.5 rounded-md text-Delete cursor-pointer"
                      onClick={() => {
                        console.log("Delete clicked");
                        setSelectedId([params.row.Id as number]);
                        openDeleteModal();
                      }}
                      // Call the export function here
                    >
                      <Tooltip title="Delete">
                        <Delete sx={{ fontSize: "20px" }} />
                      </Tooltip>
                    </div>
                  </div>
                ) : null}
              </div>
            ),
          },
        ]
      : []),

    {
      field: "Is_Active",
      headerName: "Status",
      cellClassName: "text-black",
      width: 200,
      headerAlign: "center",
      align: "center",
      headerClassName:
        "bg-primary text-white font-bold flex flex-row items-center ",
      type: "boolean",
      //render true if 1 else render false
      // valueFormatter: (params) => (params.value === 1 ? "Active" : "Inactive"),
      renderCell: (params) => (
        <WrapTextCell value={params.value === 1 ? "Active" : "Inactive"} />
      ),
    },
    {
      field: "Created_Date",
      headerName: "Created On",
      cellClassName: "text-black",
      // width: 332,
      minWidth: 300,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName:
        "bg-primary text-white font-bold flex flex-row items-center ",
      // valueFormatter: (params) => formatDate(params.value as string),
    },
  ];

  const handleViewClick = (roleid: number) => {
    console.log("View clicked");
    const eid = base64encode(roleid);

    navigate(`/roles/view/${eid}`);
  };

  const buttonVariants = {
    hidden: { opacity: 0, scale: 0, transition: { duration: 0.3 } },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
  };

  //Permissions:

  useEffect(() => {
    if (permissions?.List) {
      get_roles().then((data) => {
        setRows(data);
        setLoading(false);
      });
    }
  }, [permissions]);

  const datafilter = (rows: Role[], searchValue: string) => {
    const searchColumns = ["Role_Name", "Is_Active", "Created_Date"];
    const filteredRows = rows.filter((row) => {
      return searchColumns.some((column) => {
        const value = row[column].toString();
        return value.toLowerCase().includes(searchValue.toLowerCase());
      });
    });
    return filteredRows;
  };

  return (
    <Layout PageId={4}>
      <div className="flex flex-col items-center justify-start w-full h-full">
        <div
          className="flex flex-col items-center justify-between w-full mb-2 md:mb-0 md:flex-row "
          id="actions"
        >
          {/* <div className="flex flex-row items-center justify-center order-2 w-full md:order-1 md:w-1/4 ">
            <SearchInput
              value={searchValue}
              onChange={setSearchValue}
              placeholder="Search"
            />
          </div> */}
          {/* {permissions?.Add ? (
            <div className="flex flex-row items-center order-1 w-full md:order-2 md:w-1/4 justify-normal md:justify-end">
              <AddItemButton
                label="Add Role"
                onClick={() => {
                  navigate("/roles/add");
                }}
              />
            </div>
          ) : null} */}
          <div className="flex md:justify-end mb-2 md:space-x-2 justify-between items-center w-full ">
            {permissions?.Add && (
              <AddItemButton
                label="Add role"
                size="small"
                onClick={() => {
                  navigate("/roles/add");
                }}
              />
            )}
            {/* <ActionButtonsWithDropdown /> */}
          </div>
        </div>
        <div className="flex flex-col items-start justify-start w-full mt-2 md:mt-0">
          <div className="w-full">
            <Box
              sx={{
                "& .MuiDataGrid-root": {
                  border: "none",
                  borderBottom: `2px solid ${theme.palette.primary.main}`,
                },

                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#00A99D",
                  borderBottom: "none",
                  fontWeight: "bold",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: "#fff !important",
                },

                "& .MuiDataGrid-colCell": {
                  color: `#fff !important`,
                },

                "& .MuiDataGrid-footerContainer": {
                  display: "none",
                },

                overflowX: "auto",
                "& .cellWithStatus": {
                  color: "red",
                },
              }}
            >
              <DataGrid
                rows={datafilter(rows, searchValue)}
                columns={columns}
                loading={loading}
                getRowId={getRowId}
                autoHeight
                className="w-full text-black"
                disableRowSelectionOnClick={true}
                // slots={{
                //   pagination: CustomPagination, // Custom pagination component that doesn't render anything
                // }}
                pagination
                pageSizeOptions={[5, 10, 25, 50]}
                initialState={{
                  pagination: { paginationModel: { pageSize: 5 } },
                }}
                onCellClick={(params) => {
                  if (params.field === "action" && params.row) {
                    console.log("clicked", params.row.Id);
                  }
                }}
              />
            </Box>
          </div>
        </div>
        <Modal
          open={isDeleteModalOpen}
          onClose={closeDeleteModal}
          aria-labelledby="confirm-delete-modal"
          aria-describedby="confirm-delete-modal-description"
          className="flex flex-row items-center justify-center"
        >
          {deleteModalContent()}
        </Modal>
      </div>
    </Layout>
  );
}
